import 'css-chunksrc/client/common/contextualMenu/styles.scss';export default {
  "contextualMenu": "_contextualMenu_zrw50_1",
  "button": "_button_zrw50_5",
  "moreIcon": "_moreIcon_zrw50_18",
  "list": "_list_zrw50_34",
  "menu": "_menu_zrw50_40",
  "action": "_action_zrw50_47",
  "icon": "_icon_zrw50_63",
  "up": "_up_zrw50_71"
};